import { Circle, Lock } from "lucide-react";
import { ThreadTypeBadge } from "@/components/offers/OfferCard";
import { useI18n } from "@/i18n/I18nContext";
import { PlanBadge } from "@/components/admin/ConvPlanBar";

export const ConversationList = ({ items, activeId, onOpen, admin }) => {
  const { t, fmtDate } = useI18n();
  if (!items) return null;
  if (!items.length) return <p className="p-4 text-sm text-neutral-400" data-testid="msg-empty">{t("msg.empty")}</p>;
  return (
    <ul className="divide-y divide-neutral-800" data-testid="msg-list">
      {items.map((c) => (
        <li key={c.id}>
          <button type="button" onClick={() => onOpen(c.id)} data-testid={`msg-conv-${c.id}`}
            className={`block w-full min-w-0 border-s-4 px-4 py-3 text-start transition-colors duration-150 hover:bg-white/5 ${c.category === "custom" ? "border-fuchsia-400/70" : "border-transparent"} ${c.id === activeId ? "bg-[rgba(245,197,66,0.08)]" : ""}`}>
            <span className="flex items-center gap-2">
              {c.unread && <Circle className="h-2.5 w-2.5 shrink-0 fill-[var(--gold)] text-[var(--gold)]" data-testid={`msg-conv-unread-${c.id}`} />}
              <span className={`min-w-0 flex-1 truncate text-sm ${c.unread ? "font-bold text-white" : "text-neutral-200"}`}>{c.subject}</span>
              {c.status === "closed" && <Lock className="h-3.5 w-3.5 shrink-0 text-neutral-500" aria-label={t("msg.closed")} />}
            </span>
            <span className="mt-1 flex flex-wrap items-center gap-x-2 text-xs text-neutral-500">
              {c.category === "custom" ? <PlanBadge testId={`msg-conv-plan-badge-${c.id}`} /> : <span className="text-[var(--gold-bright)]">{t(`msg.cat.${c.category}`)}</span>}
              {admin && c.thread_type && <ThreadTypeBadge type={c.thread_type} testId={`msg-conv-type-${c.id}`} />}
              {admin && c.treated && <span className="rounded-full bg-emerald-500/15 px-2 py-0.5 text-[0.65rem] font-bold uppercase text-emerald-300" data-testid={`msg-conv-treated-${c.id}`}>{t("msg.treatedOn")}</span>}
              {admin && <span className="truncate">{c.developer.brand}</span>}
              <span>{fmtDate(c.last_at)}</span>
            </span>
            {c.preview && <span className="mt-1 block truncate text-xs text-neutral-400">{c.last_author === "system" ? t("msg.system") : c.preview}</span>}
          </button>
        </li>
      ))}
    </ul>
  );
};
